import { ref } from "vue";

const params = ref(new URLSearchParams(window.location.search));
const paramsUpdated = ref(0);

// eslint-disable-next-line import/prefer-default-export
export function useQueryString() {
  function updateQueryString(filterProperty, value) {
    const stringValue =
      typeof value === "string" ? value : JSON.stringify(value);
    params.value.set(filterProperty, stringValue);
    paramsUpdated.value += 1;
    if (window.history.replaceState) {
      const newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        params.value.toString();
      window.history.replaceState({ path: newurl }, "", newurl);
    }
  }

  function removeQueryString(filterProperty) {
    params.value.delete(filterProperty);
    if (window.history.replaceState) {
      const newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        params.value.toString();
      window.history.replaceState({ path: newurl }, "", newurl);
    }
  }

  return {
    params,
    paramsUpdated,
    removeQueryString,
    updateQueryString,
  };
}
